module.exports = __webpack_public_path__ + "img/vuelogo.250511db.png";